/**
 * Textos da interface (UI copy)
 * Centraliza rótulos e mensagens para consistência e manutenção
 */

export const COPY = {
  common: {
    cancel: 'Cancelar',
    save: 'Salvar',
    saving: 'Salvando...',
    loading: 'Carregando...',
    noResults: 'Nenhum resultado encontrado',
    errorGeneric: 'Ocorreu um erro. Tente novamente.',
    success: 'Sucesso',
    actions: 'Ações',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    edit: 'Editar',
    delete: 'Excluir',
    create: 'Criar',
    refresh: 'Atualizar'
  },
  users: {
    title: 'Usuários',
    tabTenantUsers: 'Usuários dos clientes',
    tabAdminUsers: 'Usuários do VOVER ADMIN',
    name: 'Nome',
    email: 'E-mail',
    tenant: 'Cliente',
    profile: 'Perfil',
    twoFA: '2FA',
    newAdminUser: 'Novo usuário admin',
    editAdminUser: 'Editar usuário admin',
    createAdminUser: 'Novo usuário admin',
    passwordHint: 'Mín. 12 caracteres, maiúscula, minúscula, número e caractere especial',
    passwordOptionalHint: 'Deixe em branco para não alterar',
    noAdminUsers: 'Nenhum usuário admin cadastrado',
    noTenantUsers: 'Nenhum usuário encontrado',
    sendResetPassword: 'Enviar link de redefinição de senha',
    confirmActivate: 'Tem certeza que deseja ativar este usuário?',
    confirmDeactivate: 'Tem certeza que deseja inativar este usuário?',
    confirmDeactivateAdmin: 'Tem certeza que deseja inativar este usuário admin?',
    confirmActivateAdmin: 'Tem certeza que deseja ativar este usuário admin?'
  },
  tenants: {
    title: 'Clientes',
    createTestClients: 'Criar clientes de teste',
    tenantId: 'ID do cliente',
    company: 'Empresa',
    cnpj: 'CNPJ',
    noTenants: 'Nenhum tenant encontrado',
    confirmDeactivate: 'Tem certeza que deseja desativar este tenant?',
    confirmActivate: 'Tem certeza que deseja ativar este tenant?'
  },
  roles: {
    super_admin: 'Super administrador',
    admin: 'Administrador',
    operator: 'Operador',
    auditor: 'Auditor'
  }
} as const;
